import { h as R, i as S, l as z, j as t, B as c, m as L, q as k, n as q } from "./UnstyledButton-ujNMaBde.js";
import "react";
import { L as E, C as T } from "./CloseButton-Bp_UJ8Gq.js";
var d = { root: "m_a513464", icon: "m_a4ceffb", loader: "m_b0920b15", body: "m_a49ed24", title: "m_3feedf16", description: "m_3d733a3a", closeButton: "m_919a4d88" };
const V = {
  withCloseButton: !0
}, A = L((i, { radius: e, color: s }) => ({
  root: {
    "--notification-radius": e === void 0 ? void 0 : q(e),
    "--notification-color": s ? k(s, i) : void 0
  }
})), m = R((i, e) => {
  const s = S("Notification", V, i), {
    className: u,
    color: f,
    radius: D,
    loading: a,
    withCloseButton: h,
    withBorder: p,
    title: r,
    icon: n,
    children: v,
    onClose: x,
    closeButtonProps: y,
    classNames: j,
    style: B,
    styles: N,
    unstyled: l,
    vars: b,
    mod: C,
    loaderProps: _,
    role: w,
    attributes: g,
    ...P
  } = s, o = z({
    name: "Notification",
    classes: d,
    props: s,
    className: u,
    style: B,
    classNames: j,
    styles: N,
    unstyled: l,
    attributes: g,
    vars: b,
    varsResolver: A
  });
  return /* @__PURE__ */ t.jsxs(
    c,
    {
      ...o("root"),
      mod: [{ "data-with-icon": !!n || a, "data-with-border": p }, C],
      ref: e,
      role: w || "alert",
      ...P,
      children: [
        n && !a && /* @__PURE__ */ t.jsx("div", { ...o("icon"), children: n }),
        a && /* @__PURE__ */ t.jsx(E, { size: 28, color: f, ..._, ...o("loader") }),
        /* @__PURE__ */ t.jsxs("div", { ...o("body"), children: [
          r && /* @__PURE__ */ t.jsx("div", { ...o("title"), children: r }),
          /* @__PURE__ */ t.jsx(c, { ...o("description"), mod: { "data-with-title": !!r }, children: v })
        ] }),
        h && /* @__PURE__ */ t.jsx(
          T,
          {
            iconSize: 16,
            color: "gray",
            ...y,
            unstyled: l,
            onClick: x,
            ...o("closeButton")
          }
        )
      ]
    }
  );
});
m.classes = d;
m.displayName = "@mantine/core/Notification";
export {
  m as N
};
